module.exports = __webpack_public_path__ + "img/project6.bb43866d.png";